import { render, staticRenderFns } from "./CloseCashier.vue?vue&type=template&id=2a08eafe&scoped=true&"
import script from "./CloseCashier.vue?vue&type=script&lang=js&"
export * from "./CloseCashier.vue?vue&type=script&lang=js&"
import style0 from "./CloseCashier.vue?vue&type=style&index=0&id=2a08eafe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a08eafe",
  null
  
)

export default component.exports